import { cn } from '@/utils/extra'

export default function H2 ({ text, className }) {
  return (
    <div className={cn('flex w-full', className?.includes('left') ? 'justify-start' : className?.includes('right') ? 'justify-end' : 'justify-center')}>
      <h2
        className={cn(
          'text-2xl md:text-3xl lg:text-4xl font-semibold text-gray-100 max-w-2xl line-clamp-2',
          className
        )}
      >
        {text}
      </h2>
    </div>
  )
}
